import { SortInput } from '@apeiron/common'
import { OrbitalTrackFilterInput, OrbitalTrackSortBy } from '@apeiron/orbital'
import useFilterQuery, {
  FilterQueryHook,
  FilterQueryProps
} from '@src/hooks/common/router/useFilterQuery'
import { extractArray, extractValue } from '@src/util/tools/query'
import { ParsedUrlQuery } from 'querystring'
import * as R from 'ramda'
import { useMemo } from 'react'

const useOrbitalTrackFilterQuery = (props?: Props): Hook => {
  const filledProps = useMemo(() => {
    const supportUrl = R.propOr(true, 'supportUrl', props) as boolean

    const toFilter = (query: ParsedUrlQuery): OrbitalTrackFilterInput => {
      return {
        agingBuffMax: extractValue<number>(query, 'agingBuffMax'),
        agingBuffMin: extractValue<number>(query, 'agingBuffMin'),
        isOpenRent: extractValue<boolean>(query, 'isOpenRent'),
        rentalDurationMax: extractValue<number>(query, 'rentalDurationMax'),
        rentalDurationMin: extractValue<number>(query, 'rentalDurationMin'),
        rentalFeeMax: extractValue<number>(query, 'rentalFeeMax'),
        rentalFeeMin: extractValue<number>(query, 'rentalFeeMin'),
        tier: extractArray(query, 'tier'),
        totalTrackCountMax: extractValue<number>(query, 'totalTrackCountMax'),
        totalTrackCountMin: extractValue<number>(query, 'totalTrackCountMin')
      }
    }

    const toSort = (query: ParsedUrlQuery): SortInput<OrbitalTrackSortBy> => {
      return {
        sortBy: R.propOr(OrbitalTrackSortBy.ListingTimeDesc, 'sortBy', query)
      }
    }

    return {
      supportUrl,
      queryToFilterInput: toFilter,
      queryToSortInput: toSort,
      excludedSearchParams: ['page']
    }
  }, [props])

  const {
    filterInput,
    isReady,
    sortInput,
    setBothInput,
    setFilterInput,
    setSortInput
  } = useFilterQuery(filledProps)

  return {
    filterInput,
    isReady,
    sortInput,
    setBothInput,
    setFilterInput,
    setSortInput
  }
}

type Props = Omit<
  FilterQueryProps<OrbitalTrackFilterInput, OrbitalTrackSortBy>,
  'queryToFilterInput' | 'queryToSortInput'
>

type Hook = FilterQueryHook<OrbitalTrackFilterInput, OrbitalTrackSortBy>

export default useOrbitalTrackFilterQuery
